import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { KpiPageDto, ReportingService } from '../reporting.service';
import { KpiResponse, ReportingFilterDto } from '../models/reporting.model';

interface ApiKpi { kpiCode?: string; code?: string; kpiLabel?: string; label?: string; value?: number; previousValue?: number; unit?: string; trend?: number; variant?: string; [key: string]: unknown; }
interface ApiReportingResponse { filters?: ReportingFilterDto; kpis?: ApiKpi[]; content?: ApiKpi[]; [key: string]: unknown; }

@Injectable()
export class ReportingApiService extends ReportingService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiBaseUrl}/api/v1/reporting/kpis`;

  getKpis(filter: ReportingFilterDto): Observable<KpiPageDto> {
    let params = new HttpParams();
    for (const key of ['creditorId', 'agentId', 'teamId', 'dateFrom', 'dateTo', 'period', 'reportType'] as const) {
      const value = filter[key];
      if (value) params = params.set(key, value);
    }
    return this.http.get<ApiReportingResponse | ApiKpi[]>(this.url, { params }).pipe(
      map(response => {
        const kpis = Array.isArray(response) ? response : (response.kpis ?? response.content ?? []);
        return { filters: Array.isArray(response) ? filter : { ...filter, ...(response.filters ?? {}) }, kpis: kpis.map(mapKpi) };
      }),
    );
  }
}

export function mapKpi(dto: ApiKpi): KpiResponse {
  const variant = String(dto.variant ?? 'standard').toLowerCase();
  return {
    kpiCode: String(dto.kpiCode ?? dto.code ?? ''), kpiLabel: String(dto.kpiLabel ?? dto.label ?? ''),
    value: typeof dto.value === 'number' ? dto.value : 0, previousValue: typeof dto.previousValue === 'number' ? dto.previousValue : undefined,
    unit: String(dto.unit ?? ''), trend: typeof dto.trend === 'number' ? dto.trend : undefined,
    variant: (['standard', 'success', 'warning', 'critical'] as string[]).includes(variant) ? variant as KpiResponse['variant'] : 'standard',
  };
}
